<template>
  <v-container class="pa-0"
               fluid
               full-height>
    <v-row class="full-height"
           no-gutters>
      <v-col class="full-height"
             cols="12">
        <v-row class="full-height"
               no-gutters>
          <!-- inicio de sidebar -->
          <v-col class="smartbell-sidebar pa-0 full-height"
                 cols="2">
          </v-col>
          <!-- fin de sidebar -->
          <DeleteDialog></DeleteDialog>
          <ChangeDialog></ChangeDialog>
          <v-snackbar :color="colorSnack"
                      elevation="3"
                      right
                      timeout="2000"
                      v-model="delErrSnack">
            <div class="std-text-sm std-text-white-1">{{ snackText }}</div>
            <template v-slot:action="{ attrs }">
              <v-icon @click="delErrSnack = false">mdi-close-circle-outline</v-icon>
            </template>
          </v-snackbar>
          <v-col class="full-height std-background-white-1"
                 cols="10">
            <!-- inicio de barra superior -->
            <v-row align="end"
                   class="pl-6 pr-12 cow-top-container mt-3 mb-6"
                   justify="space-between"
                   no-gutters>
              <!-- inicio de botón de regresar -->
              <v-col class="d-flex align-end" cols="3">
              </v-col>
              <!-- fin de botón de regresar -->
              <!-- inicio de cambiar de rancho -->
              <v-col cols="3">
                <ChangeRanch></ChangeRanch>
              </v-col>
              <!-- fin de cambiar de rancho -->
              <!-- inicio de tarjeta de vacas en sistema -->
              <v-col cols="3">
                <SystemCardCount :number="cowCount"
                                 height="40px"
                                 number-background="#1460AA"
                                 title="Vacas en sistema"
                                 title-background="#57A7F5"
                                 width="100%"></SystemCardCount>
              </v-col>
              <!-- fin de tarjeta de vacas en sistema -->
            </v-row>
            <!-- fin de barra superior -->

            <!--inicio de contenedor central -->
            <v-row align="center"
                   class="std-container py-0 ml-6 mr-12 std-background-white-1 std-container-shadow"
                   no-gutters>
              <v-col :class="{['std-background-blue-2'] : animalType === 'cows', ['std-background-blue-3']: animalType === 'bulls', ['std-background-blue-1']: animalType === 'heifers'}"
                     class="std-border-radius std-title-card-container d-flex align-center justify-center"
                     cols="12">
                <div class="d-flex col-6 justify-center align-baseline pa-0">
                  <div class="std-text-lg font-weight-black std-text-white-1">Potrero</div>
                  <div class="col-4 pa-0">
                    <v-autocomplete
                        :items="animalTypesList"
                        dense
                        flat
                        hide-details
                        item-text="text"
                        item-value="value"
                        solo
                        v-model="animalType"
                    >
                    </v-autocomplete>
                  </div>
                </div>
              </v-col>

              <v-col cols="12">
                <!-- inicio de contenedor de alertas -->
                <v-row class="upper-cow-container pa-3"
                       no-gutters>
                  <v-col class="full-height d-flex flex-wrap"
                         cols="6">
                    <!-- inicio de buscador por ID -->
                    <div class="col-6 upper-cow-header align-center pt-0 pb-1 offset-6">{{ animalMisc.searchTitle }}
                    </div>
                    <!-- fin de buscador por ID -->
                    <!-- inicio de botón de agregar vaca -->
                    <div class="col-6 upper-cow-item py-0">
                      <v-btn @click="openAdd('CowForm')"
                             block
                             class="smartbell-greenButton button-text d-flex justify-space-around"
                             depressed
                             elevation="3"
                             height="40px">
                        <div class="d-flex justify-space-between align-center button-text btn-text-container">
                          Agregar animal
                          <i class="dstable-cow-icon dstable-cow-wticon"></i>
                        </div>
                      </v-btn>
                    </div>
                    <!-- fin de botón de agregar vaca -->
                    <div class="col-6 upper-cow-item d-flex py-0">
                      <v-text-field
                          append-icon="search"
                          clearable
                          dense
                          outlined
                          placeholder="ID Vaca"
                          v-model="searchText"/>
                    </div>
                  </v-col>
                  <!-- fin de periodo de alertas -->
                  <!-- inicio de filtros disponibles -->
                  <v-col class="full-height d-flex flex-wrap" cols="6">
                    <div class="col-12 upper-cow-header align-center pt-0 pb-1">Filtros disponibles
                    </div>
                    <div class="col-5 upper-cow-item d-flex py-0">
                      <v-select
                          :items="firstFilterOptions"
                          dense
                          outlined
                          placeholder="Categoría"
                          v-model="firstFilterSelected"
                      />
                    </div>
                    <div class="col-7 upper-cow-item d-flex std-disabled py-0">
                      <v-select
                          :disabled="secondFilterDisabled"
                          :items="secondFilterOptions"
                          :placeholder="secondPlaceHolder"
                          dense
                          outlined
                          v-model="secondFilterSelected"
                      />
                    </div>
                  </v-col>
                  <!-- fin de filtros disponibles -->
                </v-row>
                <!-- fin de contenedor de alertas -->
                <!-- inicio contenedor de tabla -->
                <v-row align="start"
                       class="ds-table-container px-3 unselectable"
                       justify="center"
                       no-gutters>
                  <v-col class="full-height d-flex justify-center flex-wrap py-0" cols="12">
                    <!-- inicio de header de tabla -->
                    <v-row class="px-3 py-0" cols="12" no-gutters>

                      <!-- header de tabla para vacas -->
                      <div :class="{'std-background-blue-2': animalType === 'cows'}"
                           class="dsheader-table d-flex align-center justify-center col-12"
                           v-if="animalType === 'cows'">
                        <div class="dsheader-item col-3 d-flex align-center">
                          <v-checkbox dark
                                      dense
                                      hide-details
                                      label="ID Vaca"
                          >
                          </v-checkbox>
                          <i :class="{'icon-anim' : idSortedIcon}"
                             @animationend="idSortedIcon = false"
                             @click="orderBy('idInternal', idOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Raza
                          <i :class="{'icon-anim' : breedSortedIcon}"
                             @animationend="breedSortedIcon = false"
                             @click="orderBy('breed', breedOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Estado
                          <i :class="{'icon-anim' : stateSortedIcon}"
                             @animationend="stateSortedIcon = false"
                             @click="orderBy('state', stateOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-1 d-flex justify-center align-center pa-0">
                          DIM
                          <i :class="{'icon-anim' : dimSortedIcon}"
                             @animationend="dimSortedIcon = false"
                             @click="orderBy('dim', dimOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Grupo
                          <i :class="{'icon-anim' : groupSortedIcon}"
                             @animationend="groupSortedIcon = false"
                             @click="orderBy('group', groupOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Acciones
                        </div>
                      </div>
                      <!-- fin de header de tabla para vacas -->

                      <!-- header de tabla para toros -->
                      <div :class="{'std-background-blue-3': animalType === 'bulls'}"
                           class="dsheader-table d-flex align-center justify-center col-12"
                           v-if="animalType === 'bulls'">
                        <div class="dsheader-item col-3 d-flex align-center">
                          <v-checkbox
                              dark
                              dense
                              hide-details
                              label="ID Toro">
                          </v-checkbox>
                          <i :class="{'icon-anim' : idSortedIcon}"
                             @animationend="idSortedIcon = false"
                             @click="orderBy('idInternal', idOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Raza
                          <i :class="{'icon-anim' : breedSortedIcon}"
                             @animationend="breedSortedIcon = false"
                             @click="orderBy('breed', breedOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Nombre<i class="std-vertical-arrow-icon"></i>
                        </div>
                        <div class="dsheader-item col-3 d-flex justify-center align-center pa-0">
                          ID SINIIGA
                          <i :class="{'icon-anim' : idSiniigaSortedIcon}"
                             @animationend="idSiniigaSortedIcon = false"
                             @click="orderBy('idSiniiga', idSiniigaOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Acciones
                        </div>
                      </div>
                      <!-- fin de header de tabla para toros -->

                      <!-- header de tabla para vaquillas -->
                      <div :class="{'std-background-blue-1': animalType === 'heifers'}"
                           class="dsheader-table d-flex align-center justify-center col-12"
                           v-if="animalType === 'heifers'">
                        <div class="dsheader-item col-3 d-flex align-center">
                          <v-checkbox dark
                                      dense
                                      hide-details
                                      label="ID Vaquilla"
                          ></v-checkbox>
                          <i :class="{'icon-anim' : idSortedIcon}"
                             @animationend="idSortedIcon = false"
                             @click="orderBy('idInternal', idOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center ">
                          Raza
                          <i :class="{'icon-anim' : breedSortedIcon}"
                             @animationend="breedSortedIcon = false"
                             @click="orderBy('breed', breedOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Grupo
                          <i :class="{'icon-anim' : groupSortedIcon}"
                             @animationend="groupSortedIcon = false"
                             @click="orderBy('group', groupOrderFlag)"
                             class="std-vertical-arrow-icon">
                          </i>
                        </div>
                        <div class="dsheader-item col-3 d-flex justify-center align-center pa-0">
                          Etapa reproductiva<i class="std-vertical-arrow-icon"></i>
                        </div>
                        <div class="dsheader-item col-2 d-flex justify-center align-center">
                          Acciones
                        </div>
                      </div>
                      <!-- header de tabla para vaquillas -->

                    </v-row>
                    <!-- fin de header de tabla -->
                    <!-- inicio de contenido de tabla -->
                    <v-row align-content="start"
                           class="dstable-container col-12 py-0 px-3"
                           no-gutters>
                      <v-col :class="[{'first-row' : index === 0}, {'std-pointer' : animalType !== 'bulls'}]"
                             :key="item.id"
                             @click="openProfile(item)"
                             class="d-flex align-center justify-center dstable-row"
                             cols="12"
                             v-for="(item, index) in animalsTemp"
                             v-ripple>
                        <div class="col-3 align-center justify-start dsrow-item py-0 d-flex">
                          <div class="align-center justify-start d-flex pa-0 col-12"
                               style="position:relative;">
                            <v-checkbox dense
                                        hide-details
                                        id="dash-cow-id">
                            </v-checkbox>
                            <div class="d-inline-flex mr-3">
                              <i class="dstable-cow-icon" v-if="animalType === 'cows'"></i>
                              <i class="dstable-heifer-icon" v-if="animalType === 'heifers'"></i>
                              <i class="dstable-bull-icon" v-if="animalType === 'bulls'"></i>
                            </div>
                            <div class="d-inline-flex mr-2">{{ item.idInternal.toString().slice(0, 6) }}</div>
                            <div class="d-inline-flex" style="position: absolute; right: 0">
                              <div class="d-inline-flex mr-1">
                                <i class="ds-ltl-icon ds-medical"></i></div>
                              <div class="d-inline-flex mr-1">
                                <i class="ds-ltl-icon ds-kpi"></i>
                              </div>
                              <div class="d-inline-flex mr-1">
                                <i class="ds-ltl-icon ds-kpi"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-2 d-flex align-center justify-center dsrow-item">
                          {{ item.breed }}
                        </div>
                        <!-- tercer campo -->
                        <div class="col-2 d-flex align-center justify-center dsrow-item" v-if="animalType === 'cows'">
                          {{ item.state }}
                        </div>
                        <div class="col-2 d-flex align-center justify-center dsrow-item" v-if="animalType === 'bulls'">
                          <!--{{item.name}}-->
                          N/A
                        </div>
                        <div class="col-2 d-flex align-center justify-center dsrow-item"
                             v-if="animalType === 'heifers'">
                          {{ item.group }}
                        </div>
                        <!-- fin de tercer campo -->
                        <!-- cuarto campo -->
                        <div class="col-1 d-flex align-center justify-center dsrow-item" v-if="animalType === 'cows'">
                          {{ item.dim }}
                        </div>
                        <div class="col-2 d-flex align-center justify-center dsrow-item" v-if="animalType === 'cows'">
                          {{ item.group }}
                        </div>
                        <div class="col-3 d-flex align-center justify-center dsrow-item" v-if="animalType === 'bulls'">
                          {{ item.idSiniiga }}
                        </div>
                        <div class="col-3 d-flex align-center justify-center dsrow-item"
                             v-if="animalType === 'heifers'">
                          <!--{{item.reproductiveStage}}-->
                          N/A
                        </div>
                        <!-- fin de cuarto campo -->
                        <div class="col-2 d-flex align-center justify-center dsrow-item">
                          <div class="d-inline-flex mx-2" v-if="animalType === 'cows'">
                            <button @click.stop="changeAnimal(item.idInternal, item.key)"
                                    class="ds-arrows"
                                    type="button">
                            </button>
                          </div>
                          <div class="d-inline-flex mx-2">
                            <button @click.stop="deleteAnimal(item.idInternal, item.key)"
                                    class="ds-arrows std-delete"
                                    type="button">
                            </button>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <!-- fin de contenido de tabla -->
                    <v-row class="da-table-pagination col-12 pa-0"
                           no-gutters>
                      <v-col class="d-flex pa-0 justify-center align-center"
                             cols="12"
                             style="position: relative;">
                        <v-pagination :color="paginationColor"
                                      :disabled="paginationLength === 0"
                                      :length="paginationLength"
                                      :next-icon="nextIcon"
                                      :prev-icon="prevIcon"
                                      class="col-6"
                                      total-visible="10"
                                      v-model="pageSelected">
                        </v-pagination>
                        <div class="d-flex align-center justify-center"
                             style="position: absolute; right: 12px; max-width: 250px !important">
                          <div style="height: 40px">
                            <v-select :disabled="paginationLength === 0"
                                      :items="pageItems"
                                      dense
                                      height="40px"
                                      item-text="formattedText"
                                      outlined
                                      return-object
                                      v-model="pageItem"
                                      value="number">
                            </v-select>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                </v-row>
                <!-- fin de contenedor de tabla -->
              </v-col>
            </v-row>
            <!-- fin de contenedor central -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import ChangeRanch from '@/components/ChangeRanch.vue';
import SystemCardCount from "../components/SystemCardCount";
import {EventBus} from '@/views/bus.js';
import DeleteDialog from "@/components/DeleteDialog";
import ChangeDialog from "@/components/changeDialog";

export default {
  name: 'DashCow',
  components: {
    ChangeDialog,
    DeleteDialog,
    ChangeRanch,
    SystemCardCount
  },
  data() {
    return {
      delErrSnack: false,
      colorSnack: '#EB004E',
      snackText: null,
      idSortedIcon: false,
      breedSortedIcon: false,
      stateSortedIcon: false,
      dimSortedIcon: false,
      groupSortedIcon: false,
      idSiniigaSortedIcon: false,
      idOrderFlag: false,
      breedOrderFlag: false,
      stateOrderFlag: false,
      dimOrderFlag: false,
      groupOrderFlag: false,
      idSiniigaOrderFlag: false,
      paginationColor: '#1460AA',
      sortDesc: false,
      firstFilterSelected: '',
      secondFilterSelected: '',
      firstFilterOptions: ['Grupo', 'Raza', 'Estado', 'Salud', 'Bajas', 'Ninguno'],
      secondFilterOptions: [],
      secondFilterDisabled: true,
      secondPlaceHolder: '',
      searchCategory: [
        'Grupos',
        'Raza',
        'Reproducción',
        'Salud',
        'Bajas'
      ],
      searchText: '', // texto de búsqueda por identificador
      animalTypesList: [{text: 'Vacas', value: 'cows'}, {text: 'Vaquillas', value: 'heifers'}, {
        text: 'Toros',
        value: 'bulls'
      }],
      animalsToRender: [],
      animalsTemp: null,
      pageSelected: 1,
      nextIcon: 'navigate_next',
      prevIcon: 'navigate_before',
      pageItem: {number: 10, formattedText: '10 animales por hoja'},
      pageItems: [
        {number: 10, formattedText: '10 animales por hoja'},
        {number: 20, formattedText: '20 animales por hoja'},
        {number: 30, formattedText: '30 animales por hoja'},
        {number: 40, formattedText: '40 animales por hoja'},
      ],
    }
  },
  watch: {
    animals: {
      handler: function (val) {
        this.animalsTemp = val;
      },
      immediate: true,
    },
    paddock() {
      this.resetAnimals(this.$store.getters.animalType);
    },
    /**
     * Watch the changes in animalType and clean the filters, search
     * values
     */
    animalType() {
      this.searchText = '';
      this.firstFilterSelected = '';
      this.secondFilterDisabled = true;
      this.secondFilterOptions = [];
      this.secondFilterSelected = '';
    },
    /**
     * Revisa los cambios en firstFilterSelected y
     * establece los valores para secondFilterSelected y
     * secondPlaceHolder
     */
    firstFilterSelected() {
      this.secondFilterSelected = '';
      this.secondPlaceHolder = '';
      this.secondFilterOptions = [];
      this.secondFilterDisabled = false;
      this.resetAnimals(this.animalType);
      switch (this.firstFilterSelected) {
        case 'Grupo':
          this.secondFilterOptions = this.animalMisc.groups;
          this.secondPlaceHolder = 'Establo general';
          break;
        case 'Raza':
          this.secondFilterOptions = this.breeds;
          this.secondPlaceHolder = this.breeds[0];
          break;
        case 'Estado':
          this.secondFilterOptions = ['Secas', 'Lactando', 'En celo', 'Servidas', 'Gestantes', 'Recién paridas'];
          this.secondPlaceHolder = 'Secas';
          break;
        case 'Salud':
          this.secondFilterOptions = ['Saludables', 'Enfermas'];
          this.secondPlaceHolder = 'Saludables';
          break;
        case 'Bajas':
          this.secondFilterDisabled = true;
          this.secondFilterOptions = ['Vendidas', 'Rastro', 'Muertas'];
          this.secondPlaceHolder = 'Vendidas';
          break;
        case 'Ninguno':
          this.secondFilterDisabled = true;
          this.secondFilterOptions = [];
          break;
        default:
          this.secondFilterDisabled = true;
          this.secondFilterOptions = [];
      }
    },
    /**
     * Observa los cambios en secondFilterSelected
     * y restablece los animales en los cuales buscar
     */
    secondFilterSelected(filter) {
      this.resetAnimals(this.animalType); // con una búsqueda activa, restablece los animales para buscar
      if (filter !== '') {
        switch (this.firstFilterSelected) {
          case 'Raza':
            this.animalsTemp = this.animalsTemp.filter(animal => animal.breed === filter);
            break;
          case 'Estado':
            this.animalsTemp = this.animalsTemp.filter(animal => animal.state === filter);
            break;
          case 'Grupo':
            this.animalsTemp = this.animalsTemp.filter(animal => animal.group === filter);
            break;
          default:
            break;
        }
      }
    },
    /**
     * Observa los cambios en searchBar para modificar los animales a mostrar
     * @param newID el nuevo ID a buscar
     */
    searchText(newID) {
      this.secondFilterOptions = [];
      this.firstFilterSelected = '';
      this.secondFilterSelected = '';
      this.secondFilterDisabled = true;
      this.searchAnimals(newID);
    },
  },
  computed: {
    /*
    * According to the animal type, returns all the animals available
    * in firestore
    */
    animals() {
      switch (this.$store.getters.animalType) {
        case 'cows':
          return this.$store.getters.getCows;
        case 'heifers':
          return this.$store.getters.getHeifers;
        case 'bulls':
          return this.$store.getters.getBulls;
        default:
          return null;
      }
    },
    /*
    * Gets the animal type data from the store
    */
    animalType: {
      get() {
        return this.$store.getters.animalType;
      },
      set(val) {
        this.$store.commit('setAnimalType', val);
      }
    },
    /*
    * According to animal type, establishes color, groups and
    * search's title of search's input.
    */
    animalMisc() {
      let tmp = {
        searchTitle: null,
        color: null,
        groups: null
      };
      switch (this.$store.getters.animalType) {
        case 'cows':
          tmp.searchTitle = 'Buscar vaca por ID';
          tmp.color = "#1460AA";
          tmp.groups = this.getGroupNames(this.$store.getters.getCowGroups);
          break;
        case 'heifers':
          tmp.searchTitle = 'Buscar vaquilla por ID';
          tmp.groups = this.getGroupNames(this.$store.getters.getHeifers);

          tmp.color = "#57A7F5";
          break;
        case 'bulls':
          tmp.searchTitle = 'Buscar toro por ID';
          tmp.groups = this.getGroupNames(this.$store.getters.getBullGroups);
          tmp.color = "#063664";
          break;
        default:
          break;
      }
      return tmp;
    },
    /*
    * Get the paddock selected from the store
    */
    paddock() {
      return this.$store.getters.paddock;
    },
    cowCount() {
      return this.$store.getters.getCowCount;
    },
    /**
     * Calcula el número de páginas que mostrará la paginación
     */
    paginationLength() {
      return Math.floor(this.animalsToRender.length / this.pageItem.number) + 1;
    },
    /**
     * Regresa los elementos de la bitácora de acuerdo a los eventos
     * por hoja seleccionados por el usuario
     */
    paginationAnimals() {
      return this.animalsTemp.slice((this.pageSelected - 1) * this.pageItem.number, this.pageSelected * this.pageItem.number);
    },
    /**
     * Obtiene las razas de los animales presentes
     * en la base de datos
     */
    breeds() {
      let tempBreeds = [];
      this.animalsTemp.forEach((cow) => {
        if (tempBreeds.indexOf(cow.breed) === -1) {
          tempBreeds.push(cow.breed);
        }
      });
      return tempBreeds;
    },
  },
  methods: {
    /**
     * Obtiene los animales encontrados según la entrada del usuario
     */
    searchAnimals(id) {
      if (id === '' || !id) {
        this.animalsTemp = this.resetAnimals(this.animalType);
      } else {
        this.animalsTemp = this.animalsTemp.filter(animal => animal.idInternal.toLowerCase().includes(id.toLowerCase()));
      }
    },
    /**
     * Reset all animals before any other operation|
     */
    resetAnimals(type) {
      this.pageSelected = 1;
      switch (type) {
        case 'cows':
          return this.$store.getters.getCows;
        case 'heifers':
          return this.$store.getters.getHeifers;
        case 'bulls':
          return this.$store.getters.getBulls;
        default:
          return null;
      }
    },
    /**
     * Ordena los animales según los parámetros dados
     * @param itemToSort la categoría a ordenar
     * @param ascend indica la ordenación, si es ascendente o descendente
     */
    orderBy(itemToSort, ascend) {
      switch (itemToSort) {
        case 'idInternal':
          this.idOrderFlag = !this.idOrderFlag;
          this.idSortedIcon = true;
          break;
        case 'breed':
          this.breedOrderFlag = !this.breedOrderFlag;
          this.breedSortedIcon = true;
          break;
        case 'state':
          this.stateOrderFlag = !this.stateOrderFlag;
          this.stateSortedIcon = true;
          break;
        case 'dim':
          this.dimOrderFlag = !this.dimOrderFlag;
          this.dimSortedIcon = true;
          break;
        case 'group':
          this.groupOrderFlag = !this.groupOrderFlag;
          this.groupSortedIcon = true;
          break;
        case 'idSiniiga':
          this.idSiniigaOrderFlag = !this.idSiniigaOrderFlag;
          this.idSiniigaSortedIcon = true;
          break;
        default:
          break;
      }

      if (!ascend) {
        this.animalsTemp = this.animalsTemp.sort((a, b) => {
          if (a[itemToSort] > b[itemToSort]) {
            return 1;
          } else if (a[itemToSort] < b[itemToSort]) {
            return -1;
          } else {
            return 0;
          }
        });
      } else {
        this.animalsTemp = this.animalsTemp.sort((a, b) => {
          if (a[itemToSort] > b[itemToSort]) {
            return -1;
          } else if (a[itemToSort] < b[itemToSort]) {
            return 1;
          } else {
            return 0;
          }
        });
      }
    },
    /**
     * Open the cow profile component
     * @param item the animal info to open the component
     */
    openProfile(item) {
      if (this.animalType !== 'bulls') {
        this.$router.push({path: `CowProfile/${this.animalType}/${item.key}`})
        // this.$store.dispatch('fireListenCurrentAnimal', animal.key);
      }
    },
    /**
     * Deletes an animal from firestore
     * @param key the key of the animal in firestore
     * @param id the id of the animal
     */
    deleteAnimal(id, key) {
      EventBus.$emit('openDeleteDlg', {
        key: key,
        id: id,
        animalType: this.animalType,
      });
    },
    /**
     * Open the form of new animal component
     */
    openAdd() {
      this.$router.push({name: 'CowForm'})
    },
    /**
     * Returns a short version of internal id
     * @param id
     * @returns {*}
     */
    trimId(id) {
      return id.trimId(5);
    },
    /**
     * Gets an array with the group names of the selected animals
     * @params animals the selected animals
     */
    getGroupNames(animals) {
      let groups = [];
      for (let [key] of Object.entries(animals)) {
        groups.push(key);
      }
      return groups;
    },
    /**
     * Cambia a un animal del sistema
     * @param key la clave del animal a eliminar
     * @param id idInternal of the animal
     */
    changeAnimal(id, key) {
      EventBus.$emit('openChangeDlg', {
        key: key,
        animals: this.animalsTemp,
        id: id,
        animalType: this.animalType,
      });
    },
  },
  mounted() {
    EventBus.$on('errSnack', (info) => {
      if (info.type === 'del') {
        this.colorSnack = '#EB004E';
      } else {
        this.colorSnack = '#65D9AC';
      }
      this.snackText = info.text;
      this.delErrSnack = true;
    });
  },
};
</script>

<style lang="css">
@import '../style/DashCow.css';
</style>
